<template>
  <x-dialog v-model="flag" :mask-close='conf.maskClose' :can-scroll='conf.canScroll'>
    <div class="act-pop-main">
      <span class="act-pop-close" @click='close' v-if="conf.closeIcon"></span>
      <!-- 分类型弹窗 -->
      <pop :source='conf' v-bind="$attrs" v-on="$listeners" @close="flag=false"></pop>
    </div>
  </x-dialog>
</template>

<script>
import { Component, Vue } from 'vue-property-decorator'

import XDialog from '@finance/ssvue/src/components/x-dialog/index.vue'
import Pop from './customPop.vue'

@Component({
  components: {
    XDialog,
    Pop
  }
})
export default class ActPop extends Vue {
  flag = false
  conf = {
    type: 'pop',
    msg: '提示',
    btnText: '按钮',
    maskClose: false,
    canScroll: false,
    closeIcon: true,
    onShow() {},
    onBtnClick() {},
    onClose() {}
  }
  show(opt) {
    this.conf = {
      ...this.conf,
      ...opt
    }
    this.flag = true
    this.conf.onShow()
  }
  close() {
    this.flag = false
    this.conf.onClose()
  }
}
</script>

<style lang="less">
@import '../../../assets/less/var.less';

.act-pop {
  &-main {
    position: relative;
    text-align: center;
    box-sizing: border-box;
  }
  &-close {
    position: absolute;
    .wh(64, 64);
    .px2rem(right, 30);
    .px2rem(top, -84);
    .bg('/common/icon-x.png');
    // background: url('./icon-x.png') center no-repeat;
    // background-size: 100% 100%;
  }
}
</style>